module.exports = __webpack_public_path__ + "static/media/changepass.8bc74124.svg";